import React from 'react';
import { ServicesContext, useAdminService } from '~/services';
import { CreateReport, ListReports } from '~/components/Admin';

export interface ReportMarketType {
    value: number;
    label: string;
}
export function Reports() {
    const context = React.useContext(ServicesContext);
    const { getCachedMarkets } = useAdminService();
    const [marketList, setMarketList] = React.useState<ReportMarketType[]>([]);

    React.useEffect(() => {
        (async () => {
            const result = await getCachedMarkets();
            setMarketList(
                result.map((x: PatientMarketType) => ({
                    value: x.id,
                    label: x.name,
                }))
            );
        })();
    }, [getCachedMarkets]);

    if (!context.user.isGlobalAdmin()) return null;
    return (
        <>
            <div className="row mb-2">
                <div className="col-12 text-end">
                    <CreateReport marketList={marketList} />
                </div>
            </div>
            <ListReports />
        </>
    );
}
